import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { first, flatMap } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { UserStorage } from '../../user/user-storage';
import { UsersStorage } from './users-storage';
import { User } from '../../user';
import { findEditedUserPk } from '../../shared/route-helpers';

@Injectable()
export class UserResolver implements Resolve<User> {
    private currentUserPk$: Observable<User>;
    constructor(
        private userStorage: UserStorage,
        private usersStorage: UsersStorage
    ) {
        this.currentUserPk$ = this.userStorage.currentUser.pipe(first());
    }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
        return this.currentUserPk$.pipe(
            flatMap((u) => {
                const editedUserPk = findEditedUserPk(route);

                if (editedUserPk && editedUserPk !== u.metadata.userId) {
                    return this.usersStorage.getSpecificUser(editedUserPk);
                } else {
                    return this.userStorage.currentUser.pipe(first());
                }
            })
        );
    }
}